import { Skeleton } from "../ui/skeleton";

const FormLoader = (): JSX.Element => {
  return (
    <div className='mt-5 space-y-4'>
      {Array.from({ length: 2 }).map((_, index) => (
        <div className='grid grid-cols-3 gap-4 ' key={index}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton className='h-12' key={index} />
          ))}
        </div>
      ))}
      <div className='space-y-3'>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton className='h-20 ' key={index} />
        ))}
      </div>
    </div>
  );
};

export default FormLoader;
